// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"235cbaa5","453":"8287969f","455":"c0d9fec5","977":"9ae7b32f"}[chunkId] + ".chunk.js";
};